import Footer from "@components/Footer/index";
import { NavBar } from "@components/NavBar";
import { PageLoader } from "@features/common/ui/PageLoader";
import { Failure } from "@features/Failure";
import { useMyRequestsRouteVisit } from "@features/my-requests/useMyRequestsRouteVisit";
import { useQueryAppConfiguration } from "@hooks/appConfiguration/useQueryAppConfiguration";
import { useQueryCart } from "@hooks/cart";
import { RoutesConfig } from "./RoutesConfig";

function App() {
  useQueryCart();
  useMyRequestsRouteVisit();
  const { isLoading, isError } = useQueryAppConfiguration();

  if (isLoading) {
    return <PageLoader />;
  }

  if (isError) {
    return <Failure />;
  }

  return (
    <>
      <NavBar />
      <RoutesConfig />
      <Footer />
    </>
  );
}

export default App;
